import React from 'react'

import { Heading, Stack } from 'component-library-next'

import { useIntl } from '@app/intl/Intl'
import { Page } from '@app/lib/layout/Page/Page'
import { PageContent } from '@app/lib/layout/Page/PageContent'
import { PageHeader } from '@app/lib/layout/Page/PageHeader'
import { CustomerListWidget } from '@app/modules/CustomerList/CustomerListWidget'
import { NavBar } from '@app/NavBar/NavBar'

export const CustomerListPage = () => {
  const { formatMessage } = useIntl()
  return (
    <NavBar title='Mandanten'>
      <Page>
        <PageHeader>
          <Heading size={Heading.sizes.medium}>
            {formatMessage({ id: 'Lawyer.CustomerList.Heading' })}
          </Heading>
        </PageHeader>
        <PageContent>
          <Stack>
            <CustomerListWidget />
          </Stack>
        </PageContent>
      </Page>
    </NavBar>
  )
}
